<template>
  <div class="modal-merge-store">
    <el-dialog
      :visible.sync="visible"
      lock-scroll
      custom-class="greater"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="提示"
      @close="$_cancle"
    >
      <div class="content">
        <div class="tt">
          在品牌{{modalData.brandName}}下，已经存在同名门店，请确认是否重复创建？
        </div>
        <!-- 数据列表 -->
        <main class="table-box">
          <el-table
            ref="tableRef"
            v-loading="isLoading"
            class="table-list__box"
            :data="dataList"
            height="470"
            highlight-current-row
            stripe
            tooltip-effect="dark"
          >
            <el-table-column
              v-for="column in columns"
              :key="column.key"
              :prop="column.key"
              :label="column.label"
              :width="column.width"
              :resizable="false"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="操作" width="140">
              <template #default="scope">
                <el-button
                  type="primary"
                  class="edit__btn"
                  @click="$_mergeStore(scope.row)"
                >
                  合并门店
                </el-button>
              </template>
            </el-table-column>

            <template #empty>
              <span class="table-list__empty small"></span>
            </template>
          </el-table>
        </main>

        <!-- 分页 -->
        <div class="pagination__wrapper">
          <cd-pagination
            ref="pager"
            :total="pagination.total"
            :currPage="pagination.pageNow"
            :pageSize="pagination.pageSize"
            @changepage="$_changeCurrent"
            @changesize="$_changeSize"
            :explainShow="true"
            @refresh="$_getList"
          ></cd-pagination>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="save__btn" @click="$_submit">创建新门店</el-button>
          <el-button class="cancel__btn" @click="$_cancle">取 消</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "modal-merge-store",
  props: {
    modalData: { type: Object, default: () => {} },
  },
  data() {
    return {
      isLoading: false,
      visible: false,
      innerVisible: false,
      dataList: [],
      columns: [
        { key: 'storeName', label: '门店名称' },
        { key: 'address', label: '门店地址' },
        { key: 'systemNames', label: '已开通系统' }
      ],
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      }
    };
  },
  methods: {
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    $_callback() {
      this.$emit("callback");
      this.visible = false;
    },
    // 获取列表
    async $_getList() {
      this.isLoading = true
      try {
        const { pageNow, pageSize } = this.pagination
        const { sscBrandId, storeName } = this.modalData
        const params = { pageNow, pageSize, sscBrandId, storeName }
        const result = await this.$service.post("sscStoreNamePaging", params)
        this.pagination.total = result.data?.total
        this.dataList = result.data?.rows
      } finally {
        this.isLoading = false
      }
    },

    // 切换每页size
    $_changeSize(page, size){
      this.pagination.pageSize = size
      this.pagination.pageNow = 1
      this.$_getList()
    },
    // 切换当前页
    $_changeCurrent(val){
      this.pagination.pageNow = val
      this.$_getList()
    },
    // 合并门店
    async $_mergeStore(row) {
      const self = this
      const params = {
        merged: true,
        sscStoreId: row.id,
        ...this.modalData
      }
      this.$service.post("addStore", params).then(result=>{
        if (result.$.checkResult(result, true)) {
          $MessageBox.alert({
            content: result.msg,
            onOk() {
              self.$_callback()
            },
          });
        }
      })
    },

    // 保存
    async $_submit() {
      const self = this
      const params = {
        confirmCreate: true,
        ...this.modalData
      }
      await this.$service.post("addStore", params).then(result=>{
        if (result.$.checkResult(result, true)) {
          $MessageBox.alert({
            content: result.msg,
            onOk() {
              self.$_callback()
            },
          });
        }
      })
    }
  },
  mounted() {
    this.$_getList()
    this.visible = true;
  },
};
</script>

<style lang="scss">
.modal-merge-store {
  .el-dialog {
    .el-dialog__body {
      padding: 20px;
      height: auto;
      .tt {
        margin-bottom: 10px;
      }
    }
  }
  .text {
    cursor: pointer;
    color: #1895dd;
    text-decoration: underline;
  }
  .row {
    margin: 15px;
    span:first-child {
      display: inline-block;
      width: 100px;
    }
  }
}
</style>
